const SET_SELECTED_USERS = 'SET_SELECTED_USERS';
const CLEAR_SELECTED_USERS = 'CLEAR_SELECTED_USERS';
const SET_SELECTED_SERVICE_OFFERING = 'SET_SELECTED_SERVICE_OFFERING';
const CLEAR_SELECTED_SERVICE_OFFERING = 'CLEAR_SELECTED_SERVICE_OFFERING';
const REMOVED_SELECTED_SERVICE_NOW_USERS = 'REMOVED_SELECTED_SERVICE_NOW_USERS';
const SET_SELECTED_CALLER_ID = 'SET_SELECTED_CALLER_ID';
const SET_WATCH_LIST_USERS = 'SET_WATCH_LIST_USERS';
const SET_SELECTED_COMPANY = 'SET_SELECTED_COMPANY';
const RESET_FORM = 'RESET_FORM';

export const resetForm = () => ({
    type: RESET_FORM
});

export const setSelectedCompany = company => ({
    type: SET_SELECTED_COMPANY,
    company
});

export const setSelectedUsers = user => ({
    type: SET_SELECTED_USERS,
    user
});

export const clearSelectedUsers = () => ({
    type: CLEAR_SELECTED_USERS
});

export const setWatchListUsers = watchList => ({
    type: SET_WATCH_LIST_USERS,
    watchList
});

export const setSelectedServiceOffering = serviceOffering => ({
    type: SET_SELECTED_SERVICE_OFFERING,
    serviceOffering
});

export const clearSelectedServiceOffering = () => ({
    type: CLEAR_SELECTED_SERVICE_OFFERING
});

export const removeSelectedServiceNowUsers = (user, selectedUsers) => ({
    type: REMOVED_SELECTED_SERVICE_NOW_USERS,
    user,
    selectedUsers
});

export const setCallerId = callerId => ({
    type:             SET_SELECTED_CALLER_ID,
    selectedCallerId: callerId
});


// Reducer
const _defaultState = () => ({
    selectedUsers:           [],
    selectedServiceOffering: '',
    selectedCallerId:        '',
    watchList:               []
});

const _removeSelectedUser = (user, selectedUsers) => selectedUsers.filter(item => user !== item.id);


export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case SET_SELECTED_COMPANY:
        return {
            ...state,
            selectedCompany: action.company
        };
    case SET_SELECTED_USERS:
        return {
            ...state,
            selectedUsers: state.selectedUsers.concat(action.user)
        };
    case CLEAR_SELECTED_USERS:
        return {
            ...state,
            selectedUsers: []
        };
    case SET_SELECTED_SERVICE_OFFERING:
        return {
            ...state,
            selectedServiceOffering: action.serviceOffering
        };
    case CLEAR_SELECTED_SERVICE_OFFERING:
        return {
            ...state,
            selectedServiceOffering: ''
        };
    case REMOVED_SELECTED_SERVICE_NOW_USERS:
        return {
            ...state,
            watchList: _removeSelectedUser(action.user, action.selectedUsers)
        };
    case SET_SELECTED_CALLER_ID:
        return {
            ...state,
            selectedCallerId: action.selectedCallerId
        };
    case SET_WATCH_LIST_USERS:
        return {
            ...state,
            watchList: action.watchList
        };
    case RESET_FORM:
        return {
            selectedUsers:           [],
            selectedServiceOffering: '',
            watchList:               [],
            selectedCompany:         '',
            selectedCallerId:        ''
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/servicenowForm.js